export default [
    {
        // [0]
        key: "name",
        label: app.$i18n.t("Name"),
        visible: true
    },
    {
        // [1]
        key: "vehicle_models",
        label: app.$i18n.t("Model"),
        visible: true
    },
    {
        // [2]
        key: "model",
        label: app.$i18n.t("Model"),
        visible: true
    },
    {
        // [3]
        key: "brand",
        label: app.$i18n.t("Brand"),
        visible: true
    },
    {
        // [4]
        key: "type",
        label: app.$i18n.t("Type"),
        visible: true
    },
    {
        // [5]
        key: "supplier",
        label: app.$i18n.t("Supplier"),
        visible: true
    },
    {
        // [6]
        key: "entity_group",
        label: app.$i18n.t("Entity group"),
        visible: true
    },
    {
        // [7]
        key: "license_plate",
        label: app.$i18n.t("License plate"),
        visible: true
    },
    {
        // [8]
        key: "created_at",
        label: app.$i18n.t("Created at"),
        thClass: "text-center",
        tdClass: "text-center",
        visible: true
    },
    {
        // [9]
        key: "actions",
        label: app.$i18n.t("Actions"),
        thClass: "text-center",
        tdClass: "text-center",
        visible: true
    }
]